import React from 'react'
import * as PropTypes from "prop-types";

const legalNames = [
  'Positive',
  'Neutral',
  'Negative'
].reduce((soFar, x) => ({...soFar, [x]: true}), {});


export const sentimentPolarities = [
  {id: 'Positive', title: 'Positive', class: 'positive', polarity: 4, rawPolarity: 3 },
  {id: 'Neutral', title: 'Neutral', class: 'neutral', polarity: 3, rawPolarity: 2 },
  {id: 'Negative', title: 'Negative', class: 'negative', polarity: 2, rawPolarity: 1 }
]

export const sentimentToClassification = (sentiment) => {
    // Server is 2-4, not 1-3
  let rounded = roundSentiment(sentiment-1);
  if (rounded === 3) return 'Positive';
  else if (rounded === 1) return 'Negative';
  else return 'Neutral';
};

export const roundSentiment = (sentiment) => {
  // When changing these, be sure to sync them up with `Highcharts.scala`
  if (sentiment >= 2.3) return 3;
  else if (sentiment < 1.7) return 1;
  else return 2;
};

/**
 *
 * @param {number} polarity
 */
export function getPolarityModelByScore(polarity) {
  return sentimentPolarities.find((x) => x.id === sentimentToClassification(polarity));
}

export function getPolarityClassFromId(polarity) {
  return sentimentPolarities.find((x) => x.id === polarity);
}

/**
 *
 * @param {string} polarity - the id of the polarity
 */
export function getPolarityModelByName(polarity) {
  return sentimentPolarities.find((x) => x.id === polarity);
}

export default class SentimentIcon extends React.Component {


  static propTypes = {
    classification: PropTypes.string,
    polarity:  PropTypes.number,
    className: PropTypes.any
  };

  static defaultProps = {
  };


  render() {
    const {classification, polarity, className, ...rest} = this.props;

    let classificationObj;

    if (polarity !== undefined) {
      classificationObj = getPolarityModelByScore(polarity)
    } else if (legalNames[classification]) {
      classificationObj = getPolarityClassFromId(classification)
    }
    if (!classificationObj) {
      return null
    } else {
      return <i className={`sentiment pulse-icon sentiment-icon ${classificationObj.class || ''} ${className || ''}`} {...rest}/>
    }
  }
};
